var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgArrowLongRight = function SvgArrowLongRight(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m22.929 15.162-5.376-4.838.892-.99 7.218 6.495-7.218 6.495-.892-.99 5.376-4.838H6.666v-1.334h16.263Z",
    fill: "#100727"
  })));
};
export { SvgArrowLongRight as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMzIiIGhlaWdodD0iMzIiIHZpZXdCb3g9IjAgMCAzMiAzMiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik0yMi45Mjg3IDE1LjE2MjJMMTcuNTUzNCAxMC4zMjQ0TDE4LjQ0NTMgOS4zMzMzN0wyNS42NjI2IDE1LjgyODlMMTguNDQ1MyAyMi4zMjQ0TDE3LjU1MzQgMjEuMzMzNEwyMi45Mjg3IDE2LjQ5NTZINi42NjYwMlYxNS4xNjIySDIyLjkyODdaIiBmaWxsPSIjMTAwNzI3Ii8+Cjwvc3ZnPgo=";